// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"1fbf7ef0","513":"25aff805","703":"d72592db","787":"9fa4c06e"}[chunkId] + ".chunk.js";
};